import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full w-full items-center justify-center" }
const _hoisted_2 = { class: "relative items-center py-3" }
const _hoisted_3 = { class: "flex w-full justify-center" }
const _hoisted_4 = { class: "relative items-center py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Vue3JsonEditor = _resolveComponent("Vue3JsonEditor")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_form_wrapper, {
      "is-form-in-modal": _ctx.isFormInModal,
      "is-loading": _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createVNode(_component_form_divider, null, {
            default: _withCtx(() => [
              _createVNode(_component_input_field, {
                modelValue: _ctx.formData.data.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.data.name) = $event)),
                label: "Name",
                placeholder: "Enter resource name..."
              }, null, 8, ["modelValue"]),
              _createVNode(_component_input_field, {
                modelValue: _ctx.formData.data.shortName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.data.shortName) = $event)),
                label: "Short name",
                placeholder: "Enter resource short name..."
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_2, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Device", -1)),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_small_loader, {
                        key: 0,
                        height: "h-8",
                        width: "w-8"
                      }))
                    : (_openBlock(), _createBlock(_component_v_select, {
                        key: 1,
                        modelValue: _ctx.selectedAssignment,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedAssignment) = $event)),
                        "get-option-label": 
                  (deviceAssignment) => deviceAssignment.name
                ,
                        options: _ctx.mappedTdceDevices,
                        class: "w-full",
                        clearable: false
                      }, null, 8, ["modelValue", "get-option-label", "options"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Type", -1)),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.formData.data.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.data.type) = $event)),
                  options: _ctx.resourceTypes,
                  reduce: (type) => type.id,
                  class: "mt-1",
                  label: "name",
                  clearable: false
                }, null, 8, ["modelValue", "options", "reduce"])
              ]),
              _createVNode(_component_Vue3JsonEditor, {
                modelValue: _ctx.formData.data.configuration,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.data.configuration) = $event)),
                mode: "code",
                onJsonChange: _ctx.onConfigurationChange
              }, null, 8, ["modelValue", "onJsonChange"]),
              _createVNode(_component_checkbox_input, {
                modelValue: _ctx.formData.data.active,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.data.active) = $event)),
                "is-checked": _ctx.formData.data.active,
                label: "Active"
              }, null, 8, ["modelValue", "is-checked"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
        ], 32)
      ]),
      _: 1
    }, 8, ["is-form-in-modal", "is-loading"])
  ]))
}